module.exports = __webpack_public_path__ + "static/media/events_doodle.c0aec01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/events_doodle.png
// module id = 675
// module chunks = 47